<template>
  <v-delete-dialog
    :visivel="visivel"
    tipo="confirma"
    mensagem="Excluir bloco"
    corpoMensagem="Tem certeza que deseja excluir este bloco?"
    @close="$emit('close')"
    @confirma="$emit('confirma')" />
</template>

<script>
import VDeleteDialog from "@/components/dialogs/VDeleteDialog"

export default {
  name: "v-delele-bloco-dialog",
  components: { VDeleteDialog },
  props: {
    visivel: {
      type: Boolean,
    },
  },
}
</script>
